import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import GetAppIcon from '@material-ui/icons/GetApp';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import {
  DetailContext,
  DetailMode,
  DetailToolbarButton2,
} from '@eas/common-web';
import { UIElement } from '@enums';
import { useDecisionPermission } from './decision-permission';
import { useConfirmCopyAllDialog } from './dialog-actions/confirm-copy-all-hook';
import { useDownloadDocxDialog } from './dialog-actions/download-docx-hook';
import { usePrintDialog } from './dialog-actions/print-hook';

export function Toolbar() {
  const intl = useIntl();
  const { mode, source } = useContext(DetailContext);

  const { canWrite } = useDecisionPermission(source.data);
  const { handleConfirmCopyAll } = useConfirmCopyAllDialog();

  const { showButton: showPrintButton, PrintButton } = usePrintDialog();
  const {
    showButton: showDownloadButton,
    handleDownload,
    handleFullTextDownload,
    disabledAnonymizedDownload,
    disabledFullTextDownload,
  } = useDownloadDocxDialog();

  return (
    <>
      {(mode === DetailMode.EDIT || mode === DetailMode.NEW) && (
        <DetailToolbarButton2
          label={
            <span
              style={{ fontSize: '11px', lineHeight: '11px', marginTop: 5 }}
            >
              {intl.formatMessage({
                id: 'ES__DECISION__ACTIONBAR__COPY_ALL_ANONYMIZED_TEXTS',
                defaultMessage: 'Dotáhnout texty',
              })}
            </span>
          }
          startIcon={<SystemUpdateAltIcon style={{ fontSize: '14px' }} />}
          onClick={handleConfirmCopyAll}
          disabled={!canWrite(UIElement.Decision.ANONYMIZED_TEXT)}
        />
      )}
      {showPrintButton && <PrintButton />}
      {showDownloadButton && (
        <>
          <DetailToolbarButton2
            label="DOCX - AV"
            startIcon={<GetAppIcon />}
            onClick={handleDownload}
            disabled={disabledAnonymizedDownload}
          />
          <DetailToolbarButton2
            label="DOCX - PZ"
            startIcon={<GetAppIcon />}
            onClick={handleFullTextDownload}
            disabled={disabledFullTextDownload}
          />
        </>
      )}
    </>
  );
}
